import { css } from 'emotion'

export const StatusColorWidgetStyles = css`
  display: inline-block;
  width: 8px;
  height: 8px;
`
